<template>
  <div class="customerList">
    <div class="top">
      <!-- <van-search
        v-model="searchValue"
        placeholder="请输入姓名"
        show-action
        @search="searchAjax()"
      >
        <template #action>
          <div @click="searchAjax()">搜索</div>
        </template>
      </van-search>
      <van-tabs v-model="sort">
        <van-tab title="按时间排序" name="1"></van-tab>
        <van-tab title="按人数排序" name="2"></van-tab>
      </van-tabs> -->
      <div class="title">
        <p>姓名</p>
        <p>日期</p>
        <p>推广人数</p>
      </div>
    </div>
    <van-list
      v-if="list && list.length"
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多了"
      @load="nextPage()"
    >
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <p>{{ item.username }}</p>
        <p>{{ item.createTime ? $tools.dateFormat(new Date(item.createTime), 'yyyy-MM-dd') : '-' }}</p>
        <p>{{ item.recommendNum || '-' }}</p>
      </div>
    </van-list>
    <van-empty description="暂无内容" v-if="!list.length && !listLoading" />
  </div>
</template>

<script>
import { pageTools } from "@/api/mixins";
export default {
  mixins: [pageTools],
  data() {
    return {
      searchValue: "",
      sort: "1",
    };
  },
  computed: {},
  created() {
    this.initListAjax("/api/bxAgentList");
  },
  methods: {
    setListParams(params) {
      params.searchValue = this.searchValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  .title {
    display: flex;
    border-bottom: 1px solid #e7ecf6;
    p {
      flex: 1;
      font-weight: 600;
      font-size: 40px;
      text-align: center;
      line-height: 80px;
    }
  }
}
.van-list {
  // margin-top: 280px;
  margin-top: 80px;
}
.list-item {
  display: flex;
  border-bottom: 1px solid #e7ecf6;
  p {
    flex: 1;
    font-size: 40px;
    text-align: center;
    line-height: 80px;
  }
}
</style>
